<template>
  <div class="container" >
    <MvWdAisaChatHeader class="header"/>
    <div style="height: 1px; color: black;" ></div>
    <MvWdAisaChatLog class="content" ref="refAisaChatLog" @gettextlist="gettextlist" @onSendEnchancePrompt="sendEnchancePrompt" :uploadFileId="uploadFileId"/>
    <!-- messageDialog -->
    <MvWdAisaChatInputbar class="footer" ref="refAisaChatInput" @sendMsg="sendPromptMsg" @sendSWTempleMsg="sendSWTemplePromptMsg" @getFileId="receivedFileId" :isSend="isSending"/>
  </div>
</template>

<script>

// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
import { i18n } from "@/plugins/i18n.js"
import { wdConfigData } from "@/service/wd_app_config.js";
//例如: import <组件名称> from  <组建路径>
import MvWdAisaChatHeader from "./cd-chat-header.vue";
import MvWdAisaChatLog from "./cd-chat-log.vue";
import MvWdAisaChatInputbar from "./cd-chat-inputbar.vue";

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {
    MvWdAisaChatHeader,
    MvWdAisaChatLog,
    MvWdAisaChatInputbar,
  },
  props: {},
  data() {
    //这里存放数据
    return {
      isSending: false,
      uploadFileId: null
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {
    receivedFileId(fileId) {
      this.uploadFileId = fileId
    },
    gettextlist(text) {
      this.$refs.refAisaChatInput.gettextlist(text);
    },
    sendEnchancePrompt(text) {
      this.$refs.refAisaChatInput.send(text);
    },
    sendSWTemplePromptMsg(text) {
      this.$refs.refAisaChatLog.sendSWTemplePromptMsg(text);
    },
    sendPromptMsg(text) {
      this.$refs.refAisaChatLog.judgeInputIsTask(text);
    }
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    i18n.locale = wdConfigData.localLanguage
  },
  destroyed() {}, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss">

.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 0%;
}

.header {
  flex: 0 0 auto;
}

.content {
  flex: 1 1 auto; 
  overflow-y: auto; 
}

.footer {
  flex: 0 0 auto;
}
</style>
